import { Component, OnInit, OnDestroy } from "@angular/core";
import { authenticationService } from "src/app/Services/Authentication/authentication.service";
import { ViewController, AlertInput } from "@ionic/core";
import {
  PopoverController,
  ModalController,
  NavParams,
  AlertController,
  ToastController,
} from "@ionic/angular";
import { SharedService } from "src/app/Services/sheared/sharedService.service";
import { Router } from "@angular/router";
import { CotationService } from "src/app/Services/Cotation/cotation.service";
import { FactoryService } from "src/app/Services/historique/factory.service";
import { CotationAutoService } from "src/app/Services/Cotation/cotationAuto.service";
import { isUndefined } from "util";
import { BehaviorSubject, Subscription } from "rxjs";
import { SeparateurMillier } from "src/utils/Pipe/SeparateurMillier";
import { ResponseCotationPage } from "../../ResponseCotation/ResponseCotation.page";
import { PaiesimulateComponent } from "../../paiesimulate/paiesimulate.component";
import { CouvertureComponent } from "../../couverture/couverture.component";

@Component({
  selector: "app-garantiesautoComponent",
  templateUrl: "./garantiesauto.component.html",
  styleUrls: ["./garantiesauto.component.scss"],
})
export class GarantiesAutoComponent implements OnInit, OnDestroy {
  private _couverture: string = "";
  private PeriodeAuto: AlertInput[];
  objetpass: any;
  choix: string;
  choixCarte;
  choixTiers;
  choixRisque;
  TrsqOK: boolean;
  primeChauf: number;
  private dejaAfficher: boolean;
  open: boolean = false;
  private subsimul: Subscription;
  isShow: Array<boolean> = [];
  garantiesTemp = [];
   PersonChauffeur = [];
  private afficheModal:boolean
  // private PersonnesTrans = [
  //   {
  //     formule: 1,
  //     Deces: 2500000,
  //     IP: 2500000,
  //     Frais: 200000,
  //     prime: 12500,
  //     surprime: 2250,
  //     place_limit: 5,
  //     valider: true,
  //   },
  //   {
  //     formule: 2,
  //     Deces: 3000000,
  //     IP: 3000000,
  //     Frais: 250000,
  //     prime: 15000,
  //     surprime: 2700,
  //     place_limit: 5,
  //     valider: false,
  //   },
  //   {
  //     formule: 3,
  //     Deces: 4000000,
  //     IP: 4000000,
  //     Frais: 300000,
  //     prime: 20000,
  //     surprime: 3600,
  //     place_limit: 5,
  //     valider: false,
  //   },
  //   {
  //     formule: 4,
  //     Deces: 5000000,
  //     IP: 5000000,
  //     Frais: 400000,
  //     prime: 25000,
  //     surprime: 4500,
  //     place_limit: 5,
  //     valider: false,
  //   },
  // ];
  private PersonnesTrans = [
    {
      formule: 1,
      Deces: 2500000,
      IP: 2500000,
      Frais: 200000,
      prime: 10000,
      surprime: 2250,
      place_limit: 5,
      valider: true,
    },
    {
      formule: 2,
      Deces: 3000000,
      IP: 3000000,
      Frais: 250000,
      prime: 12000,
      surprime: 2700,
      place_limit: 5,
      valider: false,
    },
    {
      formule: 3,
      Deces: 4000000,
      IP: 4000000,
      Frais: 300000,
      prime: 16000,
      surprime: 3600,
      place_limit: 5,
      valider: false,
    },
    {
      formule: 4,
      Deces: 5000000,
      IP: 5000000,
      Frais: 400000,
      prime: 20000,
      surprime: 4500,
      place_limit: 5,
      valider: false,
    },
  ];
  private PersonnesTransTaxi = [
    {
      formule: 1,
      Deces: 2500000,
      IP: 3000000,
      Frais: 200000,
      prime: 35000,
      valider: true,
    },
    {
      formule: 2,
      Deces: 3500000,
      IP: 4000000,
      Frais: 300000,
      prime: 42000,
      valider: false,
    },
    {
      formule: 3,
      Deces: 4000000,
      IP: 4500000,
      Frais: 400000,
      prime: 48000,
      valider: false,
    },
    {
      formule: 4,
      Deces: 5000000,
      IP: 5500000,
      Frais: 500000,
      prime: 58000,
      valider: false,
    },
  ];
  Lesgaranties = [
    {
      Libelle_Sous_Garantie: "Responsabilité civile",
      selected: true,
      prime: 0,
      default: true,
    },
    {
      Libelle_Sous_Garantie: "Recours des tiers incendie",
      selected: true,
      prime: 0,
      default: true,
    },
    {
      Libelle_Sous_Garantie: "Extraterritotialité Carte Rose",
      selected: true,
      prime: 0,
      default: true,
    },
    {
      Libelle_Sous_Garantie: "Défense & Recours",
      selected: true,
      prime: 0,
      default: true,
    },
    {
      Libelle_Sous_Garantie: "Dommages",
      selected: false,
      prime: 0,
      default: false,
    },
    {
      Libelle_Sous_Garantie: "Bris de glaces",
      selected: false,
      prime: 0,
      default: false,
    },
    {
      Libelle_Sous_Garantie: "Incendie",
      selected: false,
      prime: 0,
      default: false,
    },
    { Libelle_Sous_Garantie: "Vol", selected: false, prime: 0, default: false },
    {
      Libelle_Sous_Garantie: "Vol à mains armées",
      selected: false,
      prime: 0,
      default: false,
    },
    {
      Libelle_Sous_Garantie: "Vol accessoires",
      selected: false,
      prime: 0,
      default: false,
    },
  ];

  constructor(
    private modalcontroller: ModalController,
    private nvparms: NavParams,
    private toastctl: ToastController,
    private fact: FactoryService,
    private sheard_: SharedService,
    private cotationService: CotationService,
    private auth: authenticationService,
    private _cotationServAuto: CotationAutoService
  ) {
    this.objetpass = this.nvparms.get("value");
    this.objetpass.typeCLi=this.objetpass.typeCLi*1
    this.objetpass.age = this._cotationServAuto.calculAgeVehicule(
      this.objetpass
    );
    this.choixCarte = "";
    this.choixTiers = "Tiers";
    this.choixRisque = "";
    this.choix = this.choixTiers;

    if (this.objetpass.age <= 3) {
      this.TrsqOK = false;
    } else {
      this.TrsqOK = true;
    }
    this.PeriodeAuto = [
      {
        name: "donne",
        type: "checkbox",
        value: "3 mois",
        label: "3 mois",
      },
      {
        name: "donne",
        type: "checkbox",
        value: "6 mois",
        label: "6 mois",
      },
      {
        name: "donne",
        type: "checkbox",
        value: "12 mois",
        label: "12 mois",
      },
    ];
    var j = 10;
    for (var i = 0; i < j; i++) {
      this.isShow.push(false);
    }
    this.isShow[0] = true; //RC
    this.isShow[3] = true; //DR
  }
  ngOnDestroy(): void {

  }
  onValidation(item) {
    this.primeChauf = 0;
    item.valider=true
    // if (item.valider) {}
     let timer=  setTimeout(() => {
        this.PersonChauffeur.filter((a) => a.formule == item.formule).map(
          (e) => (e.valider = true)
        );
        // this.primeChauf = this._cotationServAuto.calculSurprimeChauffeur(
        //   this.objetpass,
        //   item
        // );
        clearTimeout(timer)
      }, 200);

      //return
  
    // setTimeout(() => {

    // }, 200);
    this.PersonChauffeur.filter((a) => a.formule != item.formule).map(
      (e) => (e.valider = false)
    );
    this.primeChauf = this._cotationServAuto.calculSurprimeChauffeur(
      this.objetpass,
      item
    );
  }
  AfficheRC_DR() {
    this._cotationServAuto
      .calculPrimeRC_DR(this.objetpass)
      .then((result: BehaviorSubject<any[]>) => {
        result.subscribe((prime: any) => {

          
          this.Lesgaranties[0].prime = 0;
          this.Lesgaranties[3].prime = 0;
          if (prime.length === 1) {
            //this._cotationServAuto.loading2.dismiss()
            this.isShow[0] = false;
            this.isShow[3] = false;
            this.Lesgaranties[0].prime = prime[0].Prime;
            
            // Pour NSIA la DR=0
            //formule de base Math.round(prime[0].Prime * 0.1)
            this.Lesgaranties[3].prime = Math.round(prime[0].Prime * 0);
          }
        });
      });
  }
  AfficheIncendie() {
    this._cotationServAuto
      .calculPrimeInc(this.objetpass)
      .then((result: BehaviorSubject<any[]>) => {
        result.subscribe((prime: any) => {
          this.Lesgaranties[6].prime = 0;
          if (prime.length === 1) {
            //this._cotationServAuto.loading2.dismiss()
            let res = Math.round((this.objetpass.valVenale * prime[0].Taux) / 100);
            if (this.objetpass.energ==='D' && ['201','202','203'].find(e =>e===this.objetpass.Code_Cat) !==undefined) {
              res=0
            }
            this.isShow[6] = false;
            this.Lesgaranties[6].prime = isNaN(res) ? 0 : res; //Dommages
          }
        });
      });
  }
  AfficheVol() {
    this._cotationServAuto
      .calculPrimeVol(this.objetpass)
      .then((result: BehaviorSubject<any[]>) => {
        result.subscribe((prime: any) => {
          this.Lesgaranties[7].prime = 0;
          if (prime.length === 1) {
            let res = Math.round(
              (this.objetpass.valVenale * prime[0].Taux) / 100
            ); //Vol
            this.isShow[7] = false;
            this.Lesgaranties[7].prime = isNaN(res) ? 0 : res;
          }
        });
      });
  }
  AfficheVolmain() {
    this._cotationServAuto
      .calculPrimeVolmain(this.objetpass)
      .then((result: BehaviorSubject<any[]>) => {
        result.subscribe((prime: any) => {
          this.Lesgaranties[8].prime = 0;
          if (prime.length === 1) {
            //this._cotationServAuto.loading2.dismiss()
            let res = Math.round(
              (this.objetpass.valVenale * prime[0].Taux) / 100
            );
            if (this.choix == "Risque") {
              res=0
            }
            this.isShow[8] = false;
            this.Lesgaranties[8].prime = isNaN(res) ? 0 : res; //Vol mains armées
          }
        });
      });
  }
  AfficheDommage() {
    this._cotationServAuto
      .calculPrimeDommage(this.objetpass)
      .then((result: BehaviorSubject<any[]>) => {
        result.subscribe((prime: any[]) => {
          this.Lesgaranties[4].prime = 0;
          this.Lesgaranties[5].prime = 0;
          //this._cotationServAuto.loading2.dismiss()
          prime.forEach((p) => {
            this.Lesgaranties.forEach((g) => {
              if (g.Libelle_Sous_Garantie == p.Libel_Sous_garantie) {
                let res = 0;
                switch (g.Libelle_Sous_Garantie) {
                  case "Dommages":
                    if (this.choix == "Risque" && this.objetpass.age <= 3) {
                      res = Math.round((this.objetpass.valNeuf * p.Taux) / 100); //Dommages
                      this.isShow[4] = false;
                      this.Lesgaranties[4].prime = isNaN(res) ? 0 : res;
                    }
                    break;
                  case "Bris de glaces":
                    if (this.choix == "Risque") {
                      res = 0
                    this.isShow[5] = false;
                    this.Lesgaranties[5].prime = isNaN(res) ? 0 : res;
                      break
                    }
                    res = Math.round((this.objetpass.valNeuf * p.Taux) / 100); //Bris de glaces
                    this.isShow[5] = false;
                    this.Lesgaranties[5].prime = isNaN(res) ? 0 : res;

                    break;
                  default:
                    break;
                }
              }
            });
          });

          //Incendie
        });
        if (this.choix == "Risque" && this.objetpass.age <= 3) {
          this.AfficheIncendie();
        }
      });
  }

  onChecking(item, i) {
    switch (this.choix) {
      case "Tiers":
        setTimeout(() => {
          this.garantiesTemp
            .filter((a) => a.default == true)
            .map((e) => (e.selected = true));
          //Appel de la méthode de calcul
        });

        break;
      case "Risque":
        setTimeout(() => {
          // this.garantiesTemp= [].concat(this.Lesgaranties)
          this.garantiesTemp.map((e) => (e.selected = true));
        });

        break;
      case "Carte":
        setTimeout(() => {
          this.garantiesTemp
            .filter((a) => a.default == true)
            .map((e) => (e.selected = true));
          setTimeout(() => {
            this.garantiesTemp
              .filter((a) => a.selected != true)
              .map((e) => (e.prime = 0));
          });
          if (item.Libelle_Sous_Garantie == "Bris de glaces") {
            this.garantiesTemp[5].prime = 0;
            if (item.selected) {
              this.isShow[i] = true;
              this.AfficheDommage();
            }
          } else if (item.Libelle_Sous_Garantie == "Incendie") {
            this.garantiesTemp[6].prime = 0;
            if (item.selected) {
              this.isShow[i] = true;
              this.AfficheIncendie();
            }
          } else if (item.Libelle_Sous_Garantie == "Vol") {
            this.garantiesTemp[7].prime = 0;

            if (item.selected) {
              this.isShow[i] = true;
              this.AfficheVol();
            }
          } else if (item.Libelle_Sous_Garantie == "Vol à mains armées") {
            this.garantiesTemp[8].prime = 0;
            if (item.selected) {
              this.isShow[i] = true;
              this.AfficheVolmain();
            }
          }
        });

        break;
      default:
        break;
    }
  }
  onTiers() {
    this.choixTiers = "Tiers";
    this.choixCarte = "";
    this.choixRisque = "";
    this.choix = this.choixTiers;
    setTimeout(() => {
      this.garantiesTemp = this.Lesgaranties.filter((a) => a.default == true);
      this.garantiesTemp.map((e) => (e.selected = true));
      //Appel de la méthode de calcul
    });
  }
  onRisque() {
    if (this.objetpass.age>5 )
    {
      this.presentToastWithOptions("Garanties tout risque","Vous ne pouvez pas choisir de garanties complémentaires car votre véhicule est âgé de plus de 5 ans")
      return
    }
    if (this.objetpass.valNeuf===0 && this.objetpass.valVenale===0 && this.objetpass.age<5 )
    {
      this.presentToastWithOptions("Garanties tout risque","Vous n'avez pas renseigné de montant sur la valeur à neuf et la valeur vénale du véhicule*")
      return
    } 
    
    this.choixTiers = "";
    this.choixCarte = "";
    this.choixRisque = "Risque";
    this.choix = this.choixRisque;
    setTimeout(() => {
      this.garantiesTemp = [].concat(this.Lesgaranties);
      this.garantiesTemp.map((e) => (e.selected = true));
    });
    this.Lesgaranties[4].prime = 0;
    this.Lesgaranties[5].prime = 0;
    this.Lesgaranties[6].prime = 0;
    this.Lesgaranties[7].prime = 0;
    this.Lesgaranties[8].prime = 0;
    if (this.objetpass.age <= 3) {
      this.isShow[4] = true;
      this.isShow[5] = true;
      this.isShow[6] = true;
      this.isShow[7] = true;
      this.isShow[8] = true;
      this.AfficheDommage();
      this.AfficheVol();
      this.AfficheVolmain();
    }
  }
  onCarte() {
     if (this.objetpass.age>5 )
      {
        this.presentToastWithOptions("Garanties à la carte","Vous ne pouvez pas choisir de garanties complémentaires car votre véhicule est âgé de plus de 5 ans")
        return
      }
    if (this.objetpass.valNeuf===0 && this.objetpass.valVenale===0 && this.objetpass.age<=5 )
    {
      this.presentToastWithOptions("Garanties à la carte","Vous n'avez pas renseigné de montant sur la valeur à neuf et la valeur vénale du véhicule*")
      return
    }
 
    this.choixTiers = "";
    this.choixCarte = "Carte";
    this.choixRisque = "";
    this.choix = this.choixCarte;
    setTimeout(() => {
      this.garantiesTemp = [].concat(this.Lesgaranties);
      this.garantiesTemp
        .filter((a) => a.default == true)
        .map((e) => (e.selected = true));
      this.Lesgaranties.filter((a) => a.default != true).map((e) => {
        e.selected = false;
        e.prime = 0;
      });
      //Appel de la méthode de calcul
    });
  }

  ngOnInit() {
    this.garantiesTemp = this.Lesgaranties.filter((a) => a.default == true);
    this.garantiesTemp.map((e) => (e.selected = true));
    if ("201 202 203 205 207 209 212 214".includes(this.objetpass.Code_Cat)) {
      // if (this.objetpass.Code_Cat==="205") {
      //   this.PersonnesTrans.map(e => e.valider=false)
      // }
      this.PersonChauffeur = this.PersonnesTrans;
    } else if (this.objetpass.Code_Cat == "204") {
      this.PersonChauffeur = this.PersonnesTransTaxi;
    }
    this.primeChauf = this._cotationServAuto.calculSurprimeChauffeur(
      this.objetpass,
      this.PersonChauffeur[0]
    );
   // this.checkEtatNetWork()
    this.AfficheRC_DR();
    
    this.fact.seTtracking(new Date().toISOString(),
    'L4',
    false,
    '1000',
    "",
    "Garanties Auto",
    "")
  }

  async presentToastWithOptions(header:string,msg:string) {
    const toast = await this.toastctl.create({
      animated: true,
      buttons:['OK'],
      
      //closeButtonText: 'Ok',
      // color: 'danger',
      cssClass: 'toast-success',
      duration: 10*1000,
      header: header, //'Les garanties tout risque',
      // keyboardClose: true,
      message: msg,
      mode: 'ios',
      position: 'top',
     // showCloseButton: true,
      translucent: true
    });
    toast.present();
  }

  async onCloseModal() {
    this.modalcontroller.dismiss();
  }

  async presentPeriodecouvertureAuto() {
    this.afficheModal=false
    this.cotationService.couverture.next(null)

    const modal = await this.modalcontroller.create({
      component: CouvertureComponent,
      //cssClass:'garantie-modal',
      componentProps: {
        value: {
          p1:"1",
          p2:"1",
          p3:"1",
          dte:this.objetpass.dateEffet
        },
      }
    });

    await modal.present();

    this.cotationService.couverture.subscribe((result) => {
      if (result!==null && !this.afficheModal) {
        this.afficheModal=true
        if(this.Lesgaranties.reduce((acc, curr) => Number(acc) + Number(curr.prime),0) !=0){
          this.calculPrime(result);  
        }else{
          this.auth.presentToast("Erreur réseau","Network!")
        }
        
      }
    });
  }

  calculPrime(data) {
    if (!isUndefined(data) && data.length > 0) {
      this._couverture = "";
      let laperiode = [];
      data.forEach((e) => {
        if (e.isItemChecked) {
          laperiode.push(e.value);
        }
        //this._couverture = this._couverture + e + ';'
      });
      // = this._couverture.split(';') as []
      let PrimeBaseAnnuelle = 0;
      let ObjetrimeNette;
      let Objetaccessoire;
      let Objetaxe;
      let CarteRose = 2000;
      this.dejaAfficher = false;
      this.Lesgaranties.forEach((e) => {
        PrimeBaseAnnuelle += e.prime;
      });
      PrimeBaseAnnuelle = Math.round(PrimeBaseAnnuelle * 0.8 + this.primeChauf);
      ObjetrimeNette = this._cotationServAuto.calculPrimeDuree(
        PrimeBaseAnnuelle,
        laperiode
      );
      Objetaccessoire = this._cotationServAuto.calculAccessoire(ObjetrimeNette);
      Objetaxe = this._cotationServAuto.calculTaxes(
        Objetaccessoire,
        this.objetpass.Taxe
      );

      //Calcul de la TVL
      Objetaxe.Tvl3 = Objetaxe.Tvl6 = Objetaxe.Tvl12 = this._cotationServAuto.calculTVL(
        this.objetpass
      );
      Objetaxe.cartRose3 = Objetaxe.cartRose6 = Objetaxe.cartRose12 = CarteRose;

      this.presentValidation(Objetaxe);
    }
  }
  async Resultat(_objetResult) {
    this.objetpass.garantie = this.Lesgaranties.filter((e) => e.prime > 0);
    this.objetpass.securiteRoutiere = this.PersonChauffeur.filter(
      (e) => e.valider
    );
    
    this.objetpass.choix=this.choix
    this.fact.setData(150, this.objetpass);
    this.dejaAfficher = true;
    _objetResult.TypeObjet = "AUTOMOBILE";
    _objetResult.creat="../../../assets/img/auto.jpg"
    await this.onCloseModal();

    const modal = await this.modalcontroller.create({
      component: ResponseCotationPage,
      //cssClass:'garantie-modal',
      componentProps: {
        value: _objetResult,
      },
    });

    await modal.present();
  }

  async presentValidation(ob: any) {
    let t1 =
      this.sheard_.getDateSepar().h * 60 + this.sheard_.getDateSepar().m * 1;
    let d = this.sheard_.getTimeStampFromToday();

    if (!this.dejaAfficher) {
      this.subsimul = this.cotationService
        .getdataSimulateMoney(this.auth.profile.uid)
        .subscribe((data) => {
          if (!this.dejaAfficher && data) {
            if (data.length > 0) {
              // test de validation du nombre d'heure
              let d0 = data.filter(
                (e) =>
                  t1 - (e.h * 60 + e.mm * 1) <= e.heureMax && e.dateIns == d
              );
              if (d0.length > 0) {
                this.Resultat(ob);
              } else {
                this.Resultat(ob);
                //this.paieSimulateModal(ob);
              }
            } else {
              this.Resultat(ob);
              //this.paieSimulateModal(ob);
            }
          }
        });
    }
  }

  
  private async paieSimulateModal(_objetResult) {
    this.dejaAfficher = true;
    _objetResult.type = "AUTOMOBILE";
    const modal = await this.modalcontroller.create({
      component: PaiesimulateComponent,
      cssClass: "simulatepaie-modal",
      componentProps: {
        value: _objetResult,
      },
    });

    await modal.present();
  }
}
